export class CdCardFlagsInfo {

    /// <summary>
    /// Возможность сохранить карточку "Партнеры КСК"
    /// </summary>
    static PkCanSavePartnersKckCard = "CanSavePartnersKckCard";

    /// <summary>
    /// Возможность запустить задачу на исполнение
    /// </summary>
    static PkExecutionTaskFlag = "CanExecutionTask";

    /// <summary>
    /// Возможность запустить задачу на ознакомление
    /// </summary>
    static PkAcquaintanceTaskFlag = "CanAcquaintanceTask";

    /// <summary>
    /// Возможность сделать карточку неактуальной
    /// </summary>
    static PkNotRelevantFlag = "CanNotRelevant";

    /// <summary>
    /// Возможность создания изменения (ОРД)
    /// </summary>
    static PkCreateChangesOrdFlag = "CanCreateChangesORD";

    /// <summary>
    /// Возможность возвращать на доработку
    /// </summary>
    static PkRecallForRevisionFlag = "CanRecallForRevision";

    /// <summary>
    /// Возможность создать карточку на основании
    /// </summary>
    static PkCreatedBasedFlag = "CanCreatedBased";

    /// <summary>
    /// Возможность создать копию карточки
    /// </summary>
    static PkCopyCardFlag = "CanCopyChCard";

    /// <summary>
    /// Возможность редактировать регистрационный номер
    /// </summary>
    static PkEditRegistrationNumberFlag = "CanEditRegistrationNumber";

    /// <summary>
    /// Возможность обьединять дубликаты ИДП
    /// </summary>
    static PkCanMergeDuplicatesIDP = "CanMergeDuplicatesIDP";

}